import { Badge } from "antd";
import classNames from "classnames";
import isToday from "dayjs/plugin/isToday";
import weekday from "dayjs/plugin/weekday";
import dayjs from "dayjs";
import { useTranslation } from "react-i18next";
import { calendarSliceActions, useCalendarEvents } from "@/features/calendar/model";
import { useAppDispatch, useAppSelector } from "@/services/store";
import type { Dayjs } from "dayjs";
import type { FC } from "react";
import styles from "./styles.module.scss";

type CalendarEventMobileProps = {
  date: Dayjs;
};

dayjs.extend(weekday);
dayjs.extend(isToday);

const isWeekend = (lang: string, date: Dayjs): boolean => {
  switch (lang) {
    case "en": {
      return date.weekday() === 5 || date.weekday() === 6;
    }
    case "ru": {
      return date.weekday() === 5 || date.weekday() === 6;
    }
    default: {
      return date.weekday() === 5 || date.weekday() === 6;
    }
  }
};

export const CellRenderMobile: FC<CalendarEventMobileProps> = ({ date }) => {
  const { i18n } = useTranslation();
  const dispatch = useAppDispatch();
  const { hasEvents, isFetching } = useCalendarEvents(date);
  const { selectedDate } = useAppSelector((state) => state.calendarSlice);

  const onSelectedClick = () => {
    date.isSame(dayjs(selectedDate), "day") && dispatch(calendarSliceActions.openDrawer());
  };

  return (
    <div className={classNames(styles.cell)} onClick={onSelectedClick}>
      {hasEvents && (
        <div className={styles["has-events"]}>
          <Badge color="gold" />
        </div>
      )}
      <span
        className={classNames(styles.content, {
          [styles.today]: date.isToday() && !isWeekend(i18n.language, date),
          [styles.weekend]: isWeekend(i18n.language, date),
          [styles.active]:
            date.isSame(dayjs(selectedDate), "day") &&
            !isWeekend(i18n.language, date) &&
            !date.isToday(),
          [styles["today-active"]]:
            date.isToday() &&
            date.isSame(dayjs(selectedDate), "day") &&
            !isWeekend(i18n.language, date),
          [styles["weekend-today"]]: date.isToday() && isWeekend(i18n.language, date),
          [styles["weekend-active"]]:
            date.isSame(dayjs(selectedDate), "day") && isWeekend(i18n.language, date),
          [styles.loading]: isFetching,
        })}
      >
        {date.date()}
      </span>
    </div>
  );
};
